import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
  Text,
  Badge,
  VStack,
  HStack,
  Divider,
  Alert,
  AlertIcon,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from '@chakra-ui/react';

const CampaignValidationModal = ({ isOpen, onClose, campaigns, chassisNumber }) => {
  const unreviewedCampaigns = campaigns.filter(campaign => !campaign.reviewed);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <VStack align="start" spacing={2}>
            <Text fontSize="lg" fontWeight="bold">
              Campañas del Vehículo
            </Text>
            <Text fontSize="sm" color="gray.600">
              Chasis: {chassisNumber}
            </Text>
          </VStack>
        </ModalHeader>
        <ModalCloseButton />
        
        <ModalBody>
          {unreviewedCampaigns.length > 0 && (
            <Alert status="warning" mb={4}>
              <AlertIcon />
              <Box>
                <Text fontWeight="medium">
                  Este vehículo tiene {unreviewedCampaigns.length} campaña(s) sin revisar.
                </Text>
              </Box>
            </Alert>
          )}
          
          <Accordion allowMultiple>
            {campaigns.map((campaign) => (
              <AccordionItem key={campaign.id} border="1px solid" borderColor="gray.200" borderRadius="md" mb={2}>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    <HStack spacing={3}>
                      <Text fontWeight="medium">
                        {campaign.code || campaign.name || 'Sin número'}
                      </Text>
                      <Badge 
                        colorScheme={campaign.reviewed ? "green" : "orange"}
                        variant="solid"
                      >
                        {campaign.reviewed ? "Revisada" : "Sin revisar"}
                      </Badge>
                    </HStack>
                    <Text fontSize="sm" color="gray.600" mt={1} noOfLines={2}>
                      {campaign.description}
                    </Text>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
                
                <AccordionPanel pb={4}>
                  <VStack align="start" spacing={3}>
                    <Box>
                      <Text fontWeight="medium" color="gray.700" mb={1}>Nº de campaña:</Text>
                      <Text fontSize="sm">{campaign.code || campaign.name || '—'}</Text>
                    </Box>

                    <Box>
                      <Text fontWeight="medium" color="gray.700" mb={1}>Descripción:</Text>
                      <Text fontSize="sm">{campaign.description}</Text>
                    </Box>
                    
                    <Divider />
                    
                    <HStack spacing={4}>
                      <Box>
                        <Text fontWeight="medium" color="gray.700">Fecha de creación:</Text>
                        <Text fontSize="sm">
                          {new Date(campaign.createdAt).toLocaleDateString('es-ES')}
                        </Text>
                      </Box>
                      
                      <Box>
                        <Text fontWeight="medium" color="gray.700">Estado:</Text>
                        <Badge 
                          colorScheme={campaign.reviewed ? "green" : "orange"}
                        >
                          {campaign.reviewed ? "Revisada" : "Pendiente de revisión"}
                        </Badge>
                      </Box>
                    </HStack>
                  </VStack>
                </AccordionPanel>
              </AccordionItem>
            ))}
          </Accordion>
          
          {campaigns.length === 0 && (
            <Box textAlign="center" py={8}>
              <Text color="gray.500">
                Este vehículo no tiene campañas asociadas.
              </Text>
            </Box>
          )}
        </ModalBody>

        <ModalFooter>
          <HStack spacing={3}>
            <Button variant="ghost" onClick={onClose}>
              Cerrar
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CampaignValidationModal;
